<div class="card section-card h-100" [formGroup]="validationDemoForm">
  <div class="card-header">{{ 'i18n.domain.theme-showcase.bootstrap.title' | translate }}</div>
  <div class="card-body">
    <div class="row g-3">
      <div class="col-12 col-md-6">
        <label class="form-label" for="themePreviewName">{{ 'i18n.shared.fields.name' | translate }}</label>
        <input id="themePreviewName" type="text" class="form-control" placeholder="{{ 'i18n.shared.fields.name' | translate }}" formControlName="themePreviewName" />
        <app-error-messages [control]="formFields.themePreviewName" [showUntouchedErrors]="validationAttempted"></app-error-messages>
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label" for="themePreviewNameDisabled">{{ 'i18n.shared.fields.name' | translate }} ({{'i18n.shared.disabled' | translate}})</label>
        <input id="themePreviewNameDisabled" type="text" class="form-control" value="Alpine Retail" disabled />
      </div>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-sm table-striped align-middle mb-0">
        <thead>
          <tr>
            <th scope="col">{{ 'i18n.shared.fields.name' | translate }}</th>
            <th scope="col">{{ 'i18n.shared.fields.city' | translate }}</th>
            <th scope="col">{{ 'i18n.shared.fields.active' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Alpine Retail</td>
            <td>Zurich</td>
            <td><span class="badge text-bg-success">{{ 'i18n.shared.yes' | translate }}</span></td>
          </tr>
          <tr>
            <td>Contoso Healthcare</td>
            <td>Basel</td>
            <td><span class="badge text-bg-secondary">{{ 'i18n.shared.no' | translate }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex align-items-center gap-2 mb-3 mt-5">
      <span class="badge text-bg-primary">{{ 'i18n.domain.theme-showcase.bootstrap.badgePrimary' | translate }}</span>
      <span class="badge text-bg-secondary">{{ 'i18n.domain.theme-showcase.bootstrap.badgeSecondary' | translate }}</span>
      <span class="badge text-bg-success">{{ 'i18n.domain.theme-showcase.bootstrap.badgeSuccess' | translate }}</span>
      <span class="badge text-bg-warning">{{ 'i18n.domain.theme-showcase.bootstrap.badgeWarning' | translate }}</span>
      <span class="badge text-bg-danger">{{ 'i18n.domain.theme-showcase.bootstrap.badgeDanger' | translate }}</span>
    </div>

    <div class="dropdown mb-3 mt-4">
      <button
        class="btn btn-outline-secondary dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false">
        {{ 'i18n.domain.theme-showcase.bootstrap.dropdownToggle' | translate }}
      </button>
      <ul class="dropdown-menu">
        <li><button type="button" class="dropdown-item">{{ 'i18n.domain.theme-showcase.bootstrap.dropdownItems.sync' | translate }}</button></li>
        <li><button type="button" class="dropdown-item">{{ 'i18n.domain.theme-showcase.bootstrap.dropdownItems.export' | translate }}</button></li>
        <li><button type="button" class="dropdown-item">{{ 'i18n.domain.theme-showcase.bootstrap.dropdownItems.archive' | translate }}</button></li>
      </ul>
    </div>

    <div class="d-flex flex-wrap gap-2 mb-3">
      <button type="button" class="btn btn-primary">{{ 'i18n.shared.save' | translate }}</button>
      <button type="button" class="btn btn-outline-secondary">{{ 'i18n.shared.cancel' | translate }}</button>
      <button type="button" class="btn btn-danger">{{ 'i18n.domain.theme-showcase.bootstrap.delete' | translate }}</button>
    </div>
  </div>
</div>
